import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    padding: "24px",
    alignSelf: "stretch",
    gap: "24px",
    "& *": {
      fontFamily: "var(--font-family-base) !important",
    }
  },
  paper: {
    maxWidth: "1831px !important",
    flex: 1,
  },
  hideRightSeparator: {
    "& > .MuiDataGrid-columnSeparator": {
      display: "none !important",
    },
  },
  searchIcon: {
    color: "grey",
  },
  searchBar: {
    marginBottom: "24px",
    display: "flex",
    flexDirection: "row",
    gap: '12px',
    "& .searchTextWrapper":{
      width: '466px'
    },
    "& .MuiInputBase-root": {
      height: "40px",
      padding: "0 12px",
        "&.Mui-focused":{
          "& .MuiOutlinedInput-notchedOutline":{
              borderColor: "var(--primary-main, #2196F3) !important;",
          }
        }
    },
    '& .search-setting-wrapper':{
      margin: 0,
      "& #search-setting-label":{
        fontSize: '12px',
        color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
        "&.Mui-focused":{
          color: "var(--primary-main, #2196F3);",
        }
      }
    }
  },
  searchSettingMenuItem:{
    fontFamily: "var(--font-family-base) !important",
    "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus":{
      backgroundColor: "rgba(25, 118, 210, 0.08) !important"
    }
  },
  searchTypography: {
    color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px" /* 150% */,
    letterSpacing: "0.15px",
  },
  colorBlue: {
    color: "var(--primary-light)",
    textOverflow: "ellipsis",
    fontFamily: "Inter",
    fontSize: "14px !important",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "143%",
    letterSpacing: "0.17px",
  },
  textOverflow: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  cifTextStyle: {
    color: " rgba(0, 0, 0, 0.60)",
    fontFamily: "Inter",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "14px",
  },
  placeItemCenter: {
    alignItems: "center !important",
    justifyContent: "center !important",
  },
  tooltipIcon: {
    width: "20px",
    height: "20px",
  },
  tableWrapper: {
    border: "none !important",
    marginTop: "24px",
    "& .MuiDataGrid-cell": {
      justifyContent: "flex-start",
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "143%",
      letterSpacing: "0.17px",
    },
    "& .MuiDataGrid-columnHeader": {
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "0.17px",
      padding: "0px !important",
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      padding: "0px 10px !important",
      "& .currentReportingMonth": {
        width: "100em",
        textAlign: "right",
      },
    },
  },
  rightBorder: {
    borderRight: "1px solid #ccc",
  },
  statusMessage: {
    display: "flex",
    flexDirection: "column",
    "& span": {
      color: "rgba(0, 0, 0, 0.60)",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "14px",
    },
  },
  hideSeparatorForOtherButtons: {
    padding: "0px !important",
    "& > .MuiDataGrid-columnSeparator": {
      display: "none !important",
    },
  },
  hideSeparatorForLeftButton: {
    padding: "0 0 0 2px !important",
    "& > .MuiDataGrid-columnSeparator": {
      display: "none !important",
    },
  },
  button: {
    padding: "0px 0px !important",
  },
  leftBorder: {
    borderLeft: "1px solid #ccc",
  },
  doubleStackDataCellAlignment: {
    display: "flex",
    padding: "9px 10px !important",
    flexDirection: "column",
    alignItems: "flex-start !important",
    flex: "1 0 0",
    alignSelf: "stretch",
  },
  singleStackDataCellAlignment: {
    display: "flex",
    padding: "16px 10px !important",
    alignItems: "flex-start !important",
    alignSelf: "stretch",
  },
  flagAlignment: {
    display: "flex",
    padding: "8px 10px !important",
    alignItems: "center !important",
    alignSelf: "stretch",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: "rgba(0, 0, 0, 0.00)",
  },
  chipCollection:{
    display: 'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'flex-start',
    gap: '11px'
  },
  chip: {
    backgroundColor: "#fdeded",
    borderColor: "#d32f2f",
    color: "#d32f2f",

    margin: '0 !important',
    display: 'flex',
    minHeight: 24,
    maxHeight: 24,
    borderRadius: 100,
    padding: '3px 4px',
    alignItems:'center',

    '& .MuiChip-labelSmall':{
      display: 'flex',
      padding: "0 !important",
      alignItems:'center'
}
  },
  chipActioned: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    color: "rgba(0, 0, 0, 0.6)",

    margin: '0 !important',
    display: 'flex',
    minHeight: 24,
    maxHeight: 24,
    borderRadius: 100,
    padding: '3px 4px',
    alignItems:'center',

    '& .MuiChip-labelSmall':{
      display: 'flex',
      padding: "0 !important",
      alignItems:'center'
    }
  },
  chipText: {
    color: 'var(--error-main, #D32F2F)',

    fontFamily: 'Inter',
    fontSize: "13px",
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0.16px',
    padding: '0 6px'
  },
  chipTextActioned: {
    color: 'rgba(0, 0, 0, 0.60)',
    fontFamily: 'Inter',
    fontSize: "13px",
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0.16px',
    padding: '0 6px'
  },
  chipActionedFlagOther: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    color: "rgba(0, 0, 0, 0.6)",

    maxWidth: '380px',
    minHeight: 24,
    height: 'auto',
    borderRadius: 100,

    '& .MuiChip-label':{
      display: 'flex',
      alignItems:'center',
      padding: "0 6px !important",
    }
  },
  chipTextActionedFlagOther: {
    maxWidth: '312px',
    whiteSpace: 'normal',
    display: '-webkit-box',
    WebkitLineClamp: 2,

    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    alignContent: 'left',
    color: 'rgba(0, 0, 0, 0.60)',
    fontFamily: 'Inter',
    fontSize: "13px",
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0.16px',
    padding: '0 6px'
  },
  iconButton: {
    color: "#D32F2F",
    opacity: 0.7,
    padding: 0
  },
  iconButtonActioned: {
    color: theme.palette.grey[500],
    opacity: 0.7,
    padding: 0
  },
  circularProgress: {
    zIndex: 1300,
    color: "#fff",
  },
}));
